module.exports = __webpack_public_path__ + "img/avatar-image-big.dde603c5.jpg";